export default (ra) => ({
  async homepageHeroCTAClicked (body) {
    await ra.track("Homepage Hero CTA Clicked", body)
  },

  async homepagePaginationClicked (body) {
    await ra.track("Homepage Pagination Clicked", body)
  }
})
